import { LoadSpinner } from '@calizahq/react-components-v2'
import { WorkspaceTab } from '@sales-app/context/workspace/workspace.type'
import { useFavoritesPinnedHomes } from '@sales-app/hooks/useFavoritesPinnedHomes/useFavoritesPinnedHomes'
import { RecommendedHomeRow } from '@sales-app/hooks/useFavoritesPinnedHomes/useFavoritesPinnedHomes.util'
import { useRecommendedHomesMutations } from '@sales-app/hooks/useRecommendedHomesMutations/useRecommendedHomesMutations'
import React, { FC, useCallback, useMemo } from 'react'

import { Table } from '@/components'

import { RecomendedHomesColumns } from '../RecommendedHomes/RecommendedHomes.data'

type Props = {
  bookablePerson: WorkspaceTab
}

export const PinnedAndFavorites: FC<Props> = ({ bookablePerson }) => {
  const { data: homeData, isLoading } = useFavoritesPinnedHomes()
  const { mutateCreatePin, mutateCreateFavorite, mutateRemoveFavorite, mutateRemovePin, isMutationLoading } =
    useRecommendedHomesMutations()

  const activeFilters = useMemo(() => {
    return bookablePerson.potentialBookingFilters || { listView: true }
  }, [bookablePerson.potentialBookingFilters])

  const handlePinHomeClick = useCallback(
    (home: RecommendedHomeRow) => {
      const {
        id,
        pinnedId,
        pinned,
        name,
        square_footage = 0,
        bedrooms,
        potentialBookingId,
        market,
        baths,
        displayCityId,
      } = home
      if (potentialBookingId) {
        if (!pinned && displayCityId) {
          mutateCreatePin({
            pinnedHome: {
              homeId: id,
              unitName: name,
              displayCity: market,
              state: market,
              squareFootage: square_footage,
              bedrooms,
              baths,
              potentialBookingId,
              displayCityId,
            },
          })
        } else {
          if (pinnedId) {
            mutateRemovePin({
              pinnedHomes: { ids: [pinnedId] },
            })
          }
        }
      }
    },
    [mutateCreatePin, mutateRemovePin],
  )

  const handlefavoriteHomeClick = useCallback(
    (home: RecommendedHomeRow) => {
      const { id, bookablePersonId, favoriteId, favorite } = home
      if (favorite) {
        if (favoriteId) {
          mutateRemoveFavorite({
            favoriteId: favoriteId,
            favorite: {
              userId: bookablePersonId,
            },
          })
        }
      } else {
        if (id && bookablePersonId) {
          mutateCreateFavorite({
            favorite: {
              homeId: id,
              userId: bookablePersonId,
            },
          })
        }
      }
    },
    [mutateCreateFavorite, mutateRemoveFavorite],
  )

  const homesColumns = useMemo(() => {
    const colummns = RecomendedHomesColumns(
      activeFilters,
      isMutationLoading,
      handlePinHomeClick,
      handlefavoriteHomeClick,
    )
    colummns.splice(3, 0, {
      Header: 'City',
      accessor: 'displayCityName',
      width: 30,
    })
    return colummns
  }, [activeFilters, isMutationLoading, handlePinHomeClick, handlefavoriteHomeClick])

  const data = useMemo(() => {
    return homeData || []
  }, [homeData])

  return (
    <div className="flex w-full flex-col py-8">
      {isMutationLoading || isLoading ? (
        <div className="flex h-20 w-full items-center justify-center">
          <LoadSpinner className="icon-secondary" isCurrentColor={true} size={2} />
        </div>
      ) : (
        <>
          <div className="mb-6 flex w-full flex-col">
            <Table columns={homesColumns as any} data={data} />
          </div>
        </>
      )}
    </div>
  )
}
